module.exports = __webpack_public_path__ + "img/characher.74411d1c.png";